import React, { FC, useState } from "react";
import {
  SectionWrapper,
  ArrowButtonWrapper,
  CardsRow,
  DotsWrapper,
  Dot,
  BannerWrap,
} from "./productBanner.styles";
import { Product as ProductType } from "../../api/homepage";
import { ProductBannerCard } from "./ProductBannerCard";
import ArrowRight from "../../assets/homePage/arrowright.svg";
import ProductBackground1 from "../../assets/homePage/ProductBackground1.png";
import ProductBackground2 from "../../assets/homePage/ProductBackground2.png";
import ProductBackground3 from "../../assets/homePage/ProductBackground3.png";
import colors from "../../theme/Colours";

const PAGE_SIZE = 3;
const BACKGROUND_IMAGES = [
  ProductBackground1,
  ProductBackground2,
  ProductBackground3,
];
const BORDER_COLORS = [
  colors.productBorderRed,
  colors.productBorderBlue,
  colors.productBorderRed,
];

const ProductBanner: FC<{ products: ProductType[] }> = ({ products }) => {
  const [page, setPage] = useState(0);
  const pageCount = Math.ceil(products.length / PAGE_SIZE);
  const start = page * PAGE_SIZE;
  const visible = products.slice(start, start + PAGE_SIZE);

  const handlePrev = () => {
    setPage((p) => (p === 0 ? p : p - 1));
  };
  const handleNext = () => {
    setPage((p) => (p === pageCount - 1 ? p : p + 1));
  };
  return (
    <>
      <SectionWrapper data-testid="productBanner-section">
        <BannerWrap>
          <ArrowButtonWrapper onClick={handlePrev} disabled={page === 0}>
            <img
              src={ArrowRight}
              alt="Previous"
              style={{ transform: "rotate(180deg)" }}
            />
          </ArrowButtonWrapper>

          <CardsRow>
            {visible.map((product, index) => {
              const actualIndex = start + index;
              const backgroundImage =
                BACKGROUND_IMAGES[actualIndex % BACKGROUND_IMAGES.length];
              const borderColor =
                BORDER_COLORS[actualIndex % BORDER_COLORS.length];

              return (
                <ProductBannerCard
                  key={product.id}
                  id={product.id}
                  name={product.name}
                  abv={product.abv.toString()}
                  image={product.imageMasterUrl}
                  ibu={product?.ibu?.toString() ?? "N/A"}
                  showBuyButton
                  reverse={false}
                />
              );
            })}
          </CardsRow>

          <ArrowButtonWrapper
            onClick={handleNext}
            disabled={page === pageCount - 1}
          >
            <img src={ArrowRight} alt="Next" />
          </ArrowButtonWrapper>
        </BannerWrap>
        <DotsWrapper>
          {Array.from({ length: pageCount }).map((_, index) => (
            <Dot
              key={index}
              active={index === page}
              onClick={() => setPage(index)}
            />
          ))}
        </DotsWrapper>
      </SectionWrapper>
    </>
  );
};

export default ProductBanner;
